<template>
  <div class="user_container">
    <div class="goback">
      <div @click="goback">
        <i class="el-icon-arrow-left"></i>
        <span>返回</span>
      </div>
    </div>
    <div class="search">
      <div class="pick">
        <div class="newDate" @click="showPickDate = true">
          {{ newDate }}
        </div>
        <i class="el-icon-date"></i>
        <van-popup v-model="showPickDate" position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            type="date"
            title="选择年"
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatter"
            :columns-order="['month', 'year', 'day']"
            @confirm="comfirmPickTime"
            @cancel="showPickDate = false"
          />
        </van-popup>
      </div>
      <div class="pick">
        <div class="newDate" @click="showPickText = true">
          {{ newText }}
        </div>
        <i class="el-icon-arrow-down"></i>
        <van-popup v-model="showPickText" position="bottom">
          <van-picker
            show-toolbar
            :default-index="defaultIndex"
            :columns="optionsQuarter"
            @confirm="onConfirmText"
            @cancel="showPickText = false"
          />
        </van-popup>
      </div>
    </div>
    <div class="content" v-if="badgeList.length > 0">
      <div
        class="content_list"
        v-for="(item, index) in badgeList"
        :key="index"
        @click="toDetail('/mobile/medal/publicWelfare/welfareDetail', item)"
      >
        <div class="item_con">
          <div class="title">
            <div>{{ item.title }}</div>
            <!-- <div @click="toUrl('/mobile/medal/publicWelfare/welfareList')">
              更多
            </div> -->
          </div>
          <div class="img" v-if="item?.image">
            <img :src="imgUrl + item?.image" alt="" />
          </div>
          <div class="img" v-else>
            <img src="@/assets/newMedal/publicWelfare/bg2.png" alt="" />
          </div>
          <div class="time">
            <van-icon name="clock-o" style="margin-right: 8px" />
            {{ item.startTime }}
            <span style="margin: 0 5px">—</span> {{ item?.endTime }}
          </div>
          <div class="progress">
            <el-progress
              :text-inside="true"
              :stroke-width="14"
              :percentage="(item?.applyNum / item?.num) * 100"
            ></el-progress>
            <div class="progress_text">{{ item.num }}人</div>
          </div>
          <div
            class="tag"
            @click.stop="toMoreAooly('/mobile/medal/moreApply', item)"
          >
            <div class="tag_item" v-for="(v, i) in item.headpic" :key="i">
              <div class="tag_img">
                <img :src="v.headpic" alt="" />
              </div>
              <div class="tag_name">{{ v.name }}</div>
            </div>
          </div>
          <div class="btn" v-if="item.state == 1 && item.isApply == 0">
            <el-button
              @click.stop="
                toSubmit('/mobile/medal/publicWelfare/registration', item)
              "
            >
              报名
            </el-button>
          </div>
          <div class="btn" v-if="item.state == 1 && item.isApply == 1">
            <el-button @click.stop="noSignUp(item)"> 取消报名 </el-button>
          </div>
          <!-- <div
            class="btn"
            v-if="item.state == 2"
            style="color: #666; font-size: 18px"
          >
            活动进行中!
          </div> -->
          <div
            class="btn"
            v-if="item.state == 3"
            style="color: #666; font-size: 18px"
          >
            活动已结束!
          </div>
        </div>
      </div>
    </div>
    <div class="kong_con" v-else>
      <img class="kong_img" src="@/assets/newsNotice/kong.png" alt="" />
      <div class="kong_title kong_title1">暂无公益活动</div>
    </div>
    <div class="footer">
      <el-button
        class="btn1"
        @click="toRouter('/mobile/medal/publicWelfare/historyList')"
        >历史报名记录</el-button
      >
    </div>
  </div>
</template>

<script>
import moment from "moment";
import api from "@/apis/medal";
import apis from "@/apis/publicWelfare";
import { getToken } from "@/utils/cookie";
export default {
  name: "history",
  props: {},
  components: {},
  data() {
    return {
      showPickDate: false,
      showPickText: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      newDate: moment(new Date()).format("YYYY"),
      newText: "请选择",
      textValue: "0",
      loadingOne: false,
      finishedOne: false,
      total: 0,
      page: 1,
      pageSize: 20,
      optionsQuarter: [
        {
          value: "0",
          text: "全部",
        },
        {
          value: "1",
          text: "已发布",
        },
        {
          value: "3",
          text: "已过期",
        },
      ],
      defaultIndex: 0,
      badgeList: [],
      imgUrl: "",
    };
  },
  created() {},
  mounted() {
    this.imgUrl = api.imgUrl;
    this.getInfoList();
  },
  methods: {
    //取消报名
    noSignUp(item) {
      apis
        .cancel({
          activityId: item.id,
          empNo: getToken(),
        })
        .then(() => {
          this.$message({
            message: "取消报名成功",
            type: "success",
            duration: 2000,
          });
          this.getInfoList()
        });
    },
    //格式化时间
    formatter(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return ``;
      } else if (type === "day") {
        return ``;
      }
      return val;
    },
    //返回
    goback() {
      this.$router.go(-1);
    },
    //获取列表数据
    getInfoList() {
      apis
        .homePage({
          year: this.newDate,
          place: 2,
          state: this.textValue,
          empNo: getToken(),
        })
        .then((res) => {
          if (res.code == 200) {
            const data = res.data;
            data.forEach((item) => {
              item.startTime = moment(item.startTime).format(
                "YYYY/MM/DD HH:mm"
              );
              item.endTime = moment(item.endTime).format("YYYY/MM/DD HH:mm");
            });
            this.badgeList = data;
            console.log(this.badgeList, "res111");
          }
        });
    },
    //确认时间
    comfirmPickTime(value) {
      this.newDate = moment(value).format("YYYY");
      this.currentDate = value;
      this.showPickDate = false;
      this.getInfoList();
    },
    //选择时间
    onConfirmText(value) {
      this.newText = value.text;
      this.textValue = value.value;
      this.showPickText = false;
      this.getInfoList();
    },
    //跳转历史详情
    toUrl(item) {
      localStorage.setItem("historyDetail", JSON.stringify(item));
      this.$router.push({ path: "/mobile/medal/newsNotice/historyDetail" });
    },
    //跳转
    toRouter(path) {
      this.$router.push(path);
    },
    //跳转报名
    toSubmit(path, item) {
      if (item?.applyNum == item?.num) {
        this.$message({
          type: "warning", // success error warning
          message: "当前活动报名人数已满",
          duration: 2000,
        });
      } else {
        this.$router.push({
          path: path,
          query: {
            itemUrl: JSON.stringify(item),
          },
        });
      }
    },
    //跳转详情
    toDetail(path, item) {
      this.$router.push({
        path: path,
        query: {
          id: item.id,
        },
      });
    },
    //跳转更多报名
    toMoreAooly(path, item) {
      this.$router.push({
        path: path,
        query: {
          id: item.id,
        },
      });
    },
    // toHistory() {},
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  //   width: 100%;
  min-height: 100vh;
  padding: 30px;
  // background: #fff;
  background: url("~@/assets/newMedal/bg2.png");
  background-size: 100% 100%;
  .detail_title_info {
    width: 100%;
    height: 100%;
  }
}
.goback {
  margin: 10px 0 40px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  div {
    display: flex;
    align-items: center;
  }

  i {
    font-weight: bold;
    font-size: 48px;
    margin-right: 40px;
  }

  span {
    font-size: 34px;
    flex-shrink: 0;
  }

  .goback_search {
    margin-left: 20px;
    display: flex;
    align-items: center;
    background: #fff;
    border-radius: 80px;
    height: 80px;
    // width: 58vw;
    padding: 0 30px 0 10px;

    align-items: center;
    justify-content: space-between;

    ::v-deep .el-input {
      flex: 1;
      height: 100%;

      &__inner {
        height: 100%;
        border: none;
        font-size: 28px;
        border-radius: 80px;
      }
    }

    i {
      font-size: 38px;
      margin-right: 10px !important;
    }
  }
}
.search {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: auto;
  .pick {
    width: 48%;
    height: 80px;
    border-radius: 80px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    margin-bottom: 15px;
    .newDate {
      flex: 1;
      // height: 40px;
    }
    div {
      color: #969b9e;
      font-size: 30px;
    }
    i {
      color: #969b9e;
    }
  }
}
.content {
  overflow: auto;
  height: calc(100vh - 430px);
  //   margin-top: 30px;
  &::-webkit-scrollbar {
    display: none; /* Chrome Safari */
  }
  .content_list {
    width: 100%;
    margin: 20px auto 30px;
    // height: 310px * $zoom;
    background: #fff;
    border-radius: 25px;
    .item_con {
      padding: 30px 30px 45px;
      .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        div:nth-child(1) {
          font-weight: bold;
          color: #000;
          font-size: 14px * $zoom;
        }
        div:nth-child(2) {
          color: #666;
          font-size: 10px * $zoom;
        }
      }
      .img {
        width: 100%;
        height: 120px * $zoom;
        img {
          width: 100%;
          height: 100%;
          border-radius: 40px;
        }
      }
      .time {
        color: #666;
        font-size: 11px * $zoom;
        margin: 20px 0 25px;
      }
      .progress {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 30px;
        .progress_text {
          width: 40px * $zoom;
          text-align: center;
          font-size: 11px * $zoom;
        }
        ::v-deep {
          .el-progress {
            width: calc(100% - 40px * $zoom);
          }
          .el-progress-bar__inner {
            background: #75bfcf;
          }
          .el-progress-bar__innerText {
            opacity: 0;
          }
        }
      }
      .tag {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        margin-bottom: 30px;
        .tag_item {
          margin-right: 40px;
        }
        .tag_img {
          img {
            width: 24px * $zoom;
            height: 24px * $zoom;
            border-radius: 50%;
          }
        }
        .tag_name {
          color: #666;
          font-size: 8px * $zoom;
          margin-top: 20px;
          text-align: center;
        }
      }
      .btn {
        text-align: center;
        button {
          background: #1fbe8a;
          color: #fff;
          border: none;
          font-size: 12px * $zoom;
          border-radius: 15px;
          width: 60%;
          height: 75px;
        }
      }
      ::v-deep {
        .swiper-pagination {
          width: 100%;
          height: 60px;
          bottom: -3.2vh;
          left: 0;
        }

        .swiper-pagination-bullet {
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: rgba(31, 190, 138, 1);
          margin: 0 5px;
        }
        .swiper-pagination-bullet-active {
          background-color: rgba(31, 190, 138, 1);
        }
      }
    }
  }
}

.kong_con {
  width: 100%;
  height: 60%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 50px;
  justify-content: center;
  .kong_img {
    width: 450px;
    height: 450px;
  }
  .kong_title1 {
    margin-top: 30px !important;
  }
  .kong_title {
    color: #999999;
    font-size: 26px;
    margin-top: 10px;
  }
}
.footer {
  .btn1 {
    border: 1px solid #1fbe8a;
    background: #fff;
    color: #1fbe8a;
    width: 100%;
    height: 85px;
    font-size: 10px * $zoom;
    margin: 60px 0 30px;
    border-radius: 15px;
  }
}
</style>
